import { ITableColumn } from 'CorePackage/TableModule/interfaces/ITableColumn';

import { TableColumnSortEnum } from '../enums/TableColumnSortEnum';

export function handleSortChange<T>(columns: ITableColumn<T>[], id: keyof T): ITableColumn<T>[] {
  return columns.map(columnData => {
    if (columnData.id === id) {
      const [{ sort: currentSort }] = columns.filter(column => column.id === id);
      let newSort = TableColumnSortEnum.NONE;

      if (currentSort === TableColumnSortEnum.NONE) {
        newSort = TableColumnSortEnum.ASC;
      } else if (currentSort === TableColumnSortEnum.ASC) {
        newSort = TableColumnSortEnum.DESC;
      }

      return {
        ...columnData,
        sort: newSort,
      };
    }

    return columnData;
  });
}
